import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { LocalStorageService } from "../local-storage.service";
import { LoginService } from "src/app/features/login/login.service";
import { Session } from "src/app/model/session";
import { RefreshToken } from "src/app/model/request/auth";
import { AuthService } from "../auth.service";
import { EMPTY, catchError, map, take } from "rxjs";
import { TokenR } from "src/app/model/response/token-r";


export const authGuardInjectable = (/*route: ActivatedRouteSnapshot, state: RouterStateSnapshot*/) => {

    const router: Router = inject(Router);
    const localStorageService: LocalStorageService = inject(LocalStorageService);    

    // get the session 
    let session = localStorageService.getSession();

    // if the session is not present the user can't access, he need to login
    if(session == null || session.id == 0) {
        console.warn("User not logged in, redirecting...");
        localStorage.clear();
        return router.navigate(['/auth/login']);
    }

    /*// if he is not loged in we need to refresh the token
    if(!localStorageService.isLogedIn()) {
        console.warn("Session expired, refreshing token...");
        return checkSession(session);
    }*/
    return true;
}

const checkSession = (session: Session) => {

    /*const router: Router = inject(Router);
    const authService: LoginService = inject(LoginService);
    const localStorageService: LocalStorageService = inject(LocalStorageService);

    // create the data to make tha call
    let data: RefreshToken = {
        userId: session.id,
        refreshToken: session.refreshToken,
    };

    authService.refreshToken(data).pipe(take(1)).subscribe({
        next: (response: TokenR) => {
            if(response.success.success == false) {
                console.error("Error refreshing token");
                console.error(response);
                // response = false so refresh failed, user need to login again
                return router.navigate(['/auth/login']);
            }

            // response is successful, so save data
            localStorageService.saveRefreshedToken(response);
            console.warn("Token updated successfuly");
            console.warn(response);
            return true;
        },
        error: (err: any) => {
            console.error("Error while refreshing user token");
            console.error(err);

            // clear session
            localStorageService.clearSession();            

            return router.navigate(['/auth/login']);
            
        }
    });*/
}